define('apps/classrooms/views/pdf-utils/common', [],
    /*eslint strict: [0, "function"]*/
    function() {
        /**
         * Util method to easily share chunking when creating PDF pages.
         */
        this.generateChunks = function(list, chunkSize) {
            var chunks = [];

            for (var i = 0; i < list.length; i += chunkSize) {
                chunks.push(list.slice(i, i + chunkSize));
            }

            return chunks;
        };

        return this;
    }
);

